import axiosConfig from "./axiosConfig";

export interface DeleteSiteIngestionResponse {
  deleted: string;
  esys_uuid: string;
}

const deleteSiteIngestion = async (
  authToken: string,
  siteId: string,
  esysUuid: string
): Promise<DeleteSiteIngestionResponse> => {
  const { data } = await axiosConfig.delete(`/site/${siteId}/ingestion`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
    params: { esysUuid },
  });
  return data;
};

export default deleteSiteIngestion;
